import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'

// redux
import { connect } from 'react-redux'
import mediaActions from '../../redux/component_select_media/actions'

// sub component
import MediaInfoForm from './media_info_form'

class ModalObjectInfo extends Component {
    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props
        return (
            <Modal
                visible={visible}
                title="Thêm tài liệu"
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                footer={null}
            >
                <MediaInfoForm
                    onOk={() => this._handleOK()}
                    onCancel={() => this._handleCancel()}
                />
            </Modal>
        )
    }
}

const mapStatetToProps = state => {
    return {
        visible: state.component_select_media.modalMediaInfoState,
    }
}

const mapDipatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(mediaActions.action.dismissModalCurrentMediaInfo())
        },
    }
}

export default connect(
    mapStatetToProps,
    mapDipatchToProps
)(ModalObjectInfo)
